export default __webpack_public_path__ + "21ab2032d21bb5d43b1ee0d44652591c.svg";